const getPercentValue = (part: number, whole: number) => {
  return Math.ceil((part / whole) * 100);
};

export default getPercentValue;
